class TabGroup extends HTMLElement {
  connectedCallback() {
    const buttons = this.querySelectorAll(".tab-button");
    const contents = this.querySelectorAll(".tab-content");

    if (!buttons.length || !contents.length) return;

    buttons[0].classList.add("active");
    contents[0].classList.add("active");

    buttons.forEach((btn, i) => {
      btn.addEventListener("click", () => {
        buttons.forEach(b => b.classList.remove("active"));
        btn.classList.add("active");

        contents.forEach(c => c.classList.remove("active"));
        contents[i].classList.add("active");
      });
    });
  }
}

customElements.define("tab-group", TabGroup);

